export const LoopBand = ({ loop, duration, tall }) =>
  loop && loop.end > loop.start ? (
    <div
      data-testid={tall ? undefined : "timeline-loop-region"}
      className={`absolute top-0 bottom-0 pointer-events-none border-x ${loop.enabled ? "bg-[#D99B43]/15 border-[#D99B43]/70" : "bg-stone-400/5 border-stone-500/40"}`}
      style={{ left: `${(loop.start / duration) * 100}%`, width: `${((loop.end - loop.start) / duration) * 100}%` }}
    />
  ) : null;
